import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { navigateToProjectReports } from '../../../links/index.jsx';

const handleSelect = (archived) => navigateToProjectReports({ archived });

function ArchivedFilter({ selectedArchived }) {
  const values = {
    true: 'Yes',
    false: 'No',
  };

  return (
    <div className="report-filter" style={{ flex: 1 }}>
      <div className="text-muted filter-label">Archived</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={values[selectedArchived] || 'All'}
          id="status-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem
            active={selectedArchived !== true && selectedArchived !== false}
            eventKey=""
          >
            All
          </MenuItem>
          <MenuItem active={selectedArchived === true} eventKey="true">
            Yes
          </MenuItem>
          <MenuItem active={selectedArchived === false} eventKey="false">
            No
          </MenuItem>
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}
export default ArchivedFilter;
